(function() {
  if (window.__findShadeModalInitialized__) return;
  window.__findShadeModalInitialized__ = true;

  var modal = document.querySelector('.find-shade-modal');
  var backdrop = document.querySelector('.find-shade-modal-backdrop');
  var dialog = modal && modal.querySelector('.find-shade-dialog');
  var iframe = modal && modal.querySelector('.find-shade-iframe');
  var fallback = modal && modal.querySelector('.find-shade-fallback');
  var closeBtn = modal && modal.querySelector('.find-shade-close');
  var lastActiveTrigger = null;
  var scrollY = 0;

  function openModal(url, triggerEl) {
    if (!modal || !backdrop || !dialog || !iframe) return;
    lastActiveTrigger = triggerEl || null;

    // Add loader
    var loader = modal.querySelector('.find-shade-loader');
    if (loader && !loader.parentNode) {
      // If loader was removed previously, re-add it
      modal.querySelector('.find-shade-body').appendChild(loader);
    }

    var quizUrl = url || iframe.getAttribute('data-src');
    if (!iframe.getAttribute('src')) {
        
      iframe.setAttribute('src', quizUrl);
    }

    // When iframe loads, remove loader div
    iframe.onload = function() {
      if (loader && loader.parentNode) {
        loader.parentNode.removeChild(loader);
      }

    };

    if (fallback) fallback.classList.remove('show');
    backdrop.setAttribute('aria-hidden', 'false');
    modal.setAttribute('aria-hidden', 'false');

    scrollY = window.scrollY || window.pageYOffset || 0;
    document.body.style.top = '-' + scrollY + 'px';
    document.body.classList.add('find-shade-modal-open');

    dialog.focus();
    document.addEventListener('keydown', onKeyDown);
  }



  function closeModal() {
    if (!modal || !backdrop) return;

    backdrop.setAttribute('aria-hidden', 'true');
    modal.setAttribute('aria-hidden', 'true');

    document.body.classList.remove('find-shade-modal-open');
    document.body.style.top = '';
    window.scrollTo(0, scrollY || 0);


    if (lastActiveTrigger && typeof lastActiveTrigger.focus === 'function') {
      lastActiveTrigger.focus();
    }

    document.removeEventListener('keydown', onKeyDown);
  }

  function onKeyDown(e) {
    if (e.key === 'Escape' || e.key === 'Esc') {
      e.preventDefault();
      closeModal();
      return;
    }
    if (modal.getAttribute('aria-hidden') === 'false' && e.key === 'Tab') {
      var focusable = modal.querySelectorAll('button, [href], input, select, textarea, [tabindex]:not([tabindex="-1"])');
      focusable = Array.prototype.slice.call(focusable).filter(function(el){ return !el.hasAttribute('disabled') && el.offsetParent !== null; });
      if (focusable.length === 0) return;
      var first = focusable[0];
      var last = focusable[focusable.length - 1];
      if (e.shiftKey && document.activeElement === first) {
        e.preventDefault();
        last.focus();
      } else if (!e.shiftKey && document.activeElement === last) {
        e.preventDefault();
        first.focus();
      }
    }
  }

  if (backdrop) backdrop.addEventListener('click', closeModal);
  if (closeBtn) closeBtn.addEventListener('click', closeModal);

  document.addEventListener('click', function(e) {
    var opener = e.target.closest && e.target.closest('.find-your-shade-button');
    if (opener) {
      var url = opener.getAttribute('data-find-your-shade-url') || opener.getAttribute('href');
      if (url) {
        e.preventDefault();
        openModal(url, opener);
      }
    }
  }, true);
})();